import { c as _c } from "react/compiler-runtime";
import styles from "./UserPageSubscriptions.module.scss";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { RedeemedSubscription, SubscriptionLog, SubscriptionTopUp } from "@/entities/ISubscription";
import EthereumIcon from "../utils/icons/EthereumIcon";
import EtherscanIcon from "../utils/icons/EtherscanIcon";
import { areEqualAddresses, formatAddress, getDateDisplay, getTransactionLink } from "@/helpers/Helpers";
import { mainnet } from "wagmi/chains";
import { MEMES_CONTRACT } from "@/constants";
import { Page } from "@/helpers/Types";
import Pagination from "@/components/pagination/Pagination";
export default function UserPageSubscriptionsHistory(props) {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h5>Subscription History</h5></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.redeemed || $[2] !== props.setRedeemedPage) {
    t1 = <Row className="pt-2 pb-2"><Col><RedeemedSubscriptionsAccordion history={props.redeemed} setPage={props.setRedeemedPage} /></Col></Row>;
    $[1] = props.redeemed;
    $[2] = props.setRedeemedPage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.logs || $[5] !== props.setLogsPage) {
    t2 = <Row className="pt-2 pb-2"><Col><LogAccordion logs={props.logs} setPage={props.setLogsPage} /></Col></Row>;
    $[4] = props.logs;
    $[5] = props.setLogsPage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.setTopUpPage || $[8] !== props.topups) {
    t3 = <Row className="pt-2 pb-2"><Col><TopUpAccordion history={props.topups} setPage={props.setTopUpPage} /></Col></Row>;
    $[7] = props.setTopUpPage;
    $[8] = props.topups;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <Container className="no-padding">{t0}{t1}{t2}{t3}</Container>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function RedeemedSubscriptionsAccordion(props) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Redeemed Subscriptions</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.history.data) {
    t1 = props.history.data.length > 0 ? props.history.data.map(_temp) : <div className="font-color-silver">No Redeemed Subscriptions found</div>;
    $[1] = props.history.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="d-flex flex-column gap-2">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.history.count || $[6] !== props.history.page || $[7] !== props.setPage) {
    t3 = props.history.count > 0 && props.history.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.history.page} pageSize={10} totalResults={props.history.count} setPage={props.setPage} /></div>;
    $[5] = props.history.count;
    $[6] = props.history.page;
    $[7] = props.setPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}>{t2}{t3}</Accordion.Body></Accordion.Item></Accordion>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(redeem) {
  return <RedeemedEntry key={redeem.transaction} redeem={redeem} />;
}
function LogAccordion(props) {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Log History</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.logs.data) {
    t1 = props.logs.data.length > 0 ? props.logs.data.map(_temp2) : <div className="font-color-silver">No logs found</div>;
    $[1] = props.logs.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.logs.count || $[4] !== props.logs.page || $[5] !== props.setPage) {
    t2 = props.logs.count > 0 && props.logs.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.logs.page} pageSize={10} totalResults={props.logs.count} setPage={props.setPage} /></div>;
    $[3] = props.logs.count;
    $[4] = props.logs.page;
    $[5] = props.setPage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}><div className="d-flex flex-column gap-2">{t1}{t2}</div></Accordion.Body></Accordion.Item></Accordion>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp2(log) {
  return <LogEntry key={`subscription-log-${log.id}`} log={log} />;
}
function TopUpAccordion(props) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Accordion.Button className={styles.topUpHistoryAccordionButton}><b>Top Up History</b></Accordion.Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.history.data) {
    t1 = props.history.data.length > 0 ? props.history.data.map(_temp3) : <div className="font-color-silver">No Top Ups found</div>;
    $[1] = props.history.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="d-flex flex-column gap-2">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.history.count || $[6] !== props.history.page || $[7] !== props.setPage) {
    t3 = props.history.count > 0 && props.history.count / 10 > 1 && <div className="text-center mt-3"><Pagination page={props.history.page} pageSize={10} totalResults={props.history.count} setPage={props.setPage} /></div>;
    $[5] = props.history.count;
    $[6] = props.history.page;
    $[7] = props.setPage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t0}<Accordion.Body className={styles.topUpHistoryAccordionBody}>{t2}{t3}</Accordion.Body></Accordion.Item></Accordion>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp3(topUp) {
  return <TopUpEntry key={topUp.hash} topUp={topUp} />;
}
function TopUpEntry(props) {
  const $ = _c(25);
  let t0;
  if ($[0] !== props.topUp.amount) {
    t0 = <b>+ {props.topUp.amount}</b>;
    $[0] = props.topUp.amount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><EthereumIcon /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <div className="d-flex align-items-center gap-1 no-wrap">{t0}{t1}</div>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.topUp.from_wallet) {
    t3 = <span>from: {props.topUp.from_wallet}</span>;
    $[5] = props.topUp.from_wallet;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="d-flex align-items-center gap-3">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props.topUp.transaction_date) {
    t5 = getDateDisplay(new Date(props.topUp.transaction_date));
    $[10] = props.topUp.transaction_date;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div className="font-color-silver no-wrap">{t5}</div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== props.topUp.hash) {
    t7 = getTransactionLink(mainnet.id, props.topUp.hash);
    $[14] = props.topUp.hash;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <EtherscanIcon />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7) {
    t9 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><a className="d-flex align-items-center" target="_blank" rel="noopener noreferrer" href={t7} aria-label="View transaction on Etherscan">{t8}</a></div>;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="d-flex align-items-center gap-3">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4) {
    t11 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t4}{t10}</div></div>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function LogEntry(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.log.log) {
    t0 = <div>{props.log.log}</div>;
    $[0] = props.log.log;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.log.additional_info) {
    t1 = props.log.additional_info && <div className="font-smaller font-color-silver">{props.log.additional_info}</div>;
    $[2] = props.log.additional_info;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className="d-flex flex-column gap-1">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.log.created_at) {
    t3 = getDateDisplay(new Date(props.log.created_at));
    $[7] = props.log.created_at;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="d-flex align-items-center gap-3"><div className="font-color-silver no-wrap">{t3}</div></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t2}{t4}</div></div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function RedeemedEntry(props) {
  const $ = _c(27);
  let t0;
  if ($[0] !== props.redeem.contract) {
    t0 = areEqualAddresses(props.redeem.contract, MEMES_CONTRACT) ? "Meme" : `Contract ${formatAddress(props.redeem.contract)}`;
    $[0] = props.redeem.contract;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const contractName = t0;
  let t1;
  if ($[2] !== contractName || $[3] !== props.redeem.token_id) {
    t1 = <div>Redeemed Subscription for {contractName} #{props.redeem.token_id}</div>;
    $[2] = contractName;
    $[3] = props.redeem.token_id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.redeem.address || $[6] !== props.redeem.balance_after) {
    t2 = <div className="font-smaller font-color-silver">Airdrop Address: {props.redeem.address} - Balance after redemption:{" "}{props.redeem.balance_after} ETH</div>;
    $[5] = props.redeem.address;
    $[6] = props.redeem.balance_after;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="d-flex flex-column gap-1">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props.redeem.created_at || $[12] !== props.redeem.transaction_date) {
    t4 = getDateDisplay(new Date(props.redeem.transaction_date ?? props.redeem.created_at));
    $[11] = props.redeem.created_at;
    $[12] = props.redeem.transaction_date;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <div className="font-color-silver no-wrap">{t4}</div>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== props.redeem.transaction) {
    t6 = getTransactionLink(mainnet.id, props.redeem.transaction);
    $[16] = props.redeem.transaction;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <EtherscanIcon />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6) {
    t8 = <div className="tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-h-5 tw-w-5"><a className="d-flex align-items-center" target="_blank" rel="noopener noreferrer" href={t6} aria-label="View transaction on Etherscan">{t7}</a></div>;
    $[19] = t6;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <div className="d-flex align-items-center gap-3">{t5}{t8}</div>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t3 || $[25] !== t9) {
    t10 = <div className={styles.subscriptionHistoryEntry}><div className="d-flex align-items-center justify-content-between gap-2">{t3}{t9}</div></div>;
    $[24] = t3;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}